'use client';

import { PlusIcon } from '@heroicons/react/24/solid';
import { useTranslations } from 'next-intl';

import { Button } from '@/components/atoms/Button';
import { HeroIcon } from '@/components/atoms/Icon';
import { useAuthContext } from '@/lib/contexts/auth';
import { useDialog } from '@/lib/hooks/auth/useDialog';
import { useMediaController } from '@/lib/hooks/media-controller/useMediaController';

interface Props {
  contentId: number;
}

export function PlayerAddToButton({ contentId }: Props) {
  const t = useTranslations();
  const { openAddMenu } = useMediaController();
  const { isAuthenticated } = useAuthContext();
  const { openDialog } = useDialog();

  const handleClick = () => {
    if (!isAuthenticated) {
      openDialog('auth');
      return;
    }
    openAddMenu(contentId);
  };

  return (
    <div>
      <Button
        variant="ghost"
        onClick={handleClick}
        aria-label={t('EXPANDED_PLAYER_ADD_TO')}
        aria-haspopup="dialog"
      >
        <HeroIcon icon={PlusIcon} />
      </Button>
    </div>
  );
}
